<template>
    <div class="anim-page" @click="closeAnim">
        <div class="mainView" @click.self="null">
            <!-- title -->
            <div class="mainView-title">
                <img :src="require('@/assets/images/YuliApp/badgeWall/badgeAnim/AchievementMedal.png')"/>
            </div>
            <!-- centerBox -->
            <div class="mainView-centerBox">
                <!-- 动画背底 - 旋转 -->
                <div class="mainView-centerBox-animBg"></div>
                <!-- 动画徽章 - 扭动复原 -->
                <div class="mainView-centerBox-badgeView">
                    <!-- 底部增色 用于( 金色 || 普通徽章) -->
                    <div class="mainView-centerBox-badgeView-deepBg-gold" v-if="!badgeData?.isYuli || badgeData?.isYuli?.role_type == 6"></div>
                    <!-- 底部增色 用于( 紫色 ) -->
                    <div class="mainView-centerBox-badgeView-deepBg-purple" v-if="badgeData?.isYuli?.role_type == 5"></div>
                    <!-- 底部增色 用于( 蓝色 ) -->
                    <div class="mainView-centerBox-badgeView-deepBg-blue" v-if="badgeData?.isYuli?.role_type == 4"></div>
                    <!-- 底部增色 用于( 绿色 ) -->
                    <div class="mainView-centerBox-badgeView-deepBg-green" v-if="badgeData?.isYuli?.role_type == 3"></div>
                    <!-- 底部增色 用于( 白色 ) -->
                    <div class="mainView-centerBox-badgeView-deepBg-white" v-if="badgeData?.isYuli?.role_type == 2"></div>
                    <!-- 动画空间 -->
                    <div class="mainView-centerBox-badgeView-animView" id="badgeView-animView">
                        <img v-if="badgeData?.isYuli?.id" :src="badgeData?.badgeIcon || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png')"/>
                        <img v-else :src="badgeData?.badgeIcon || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png')"/>
                        <!-- 徽章星盒 -->
                        <div class="stars-view">
                            <div class="stars-view-Rel">
                                <!-- yuliid -->
                                <div class="stars-view-yuliId" 
                                     v-if="badgeData?.isYuli"
                                     :class="{
                                        'stars-view-yuliId-gold': badgeData?.isYuli?.role_type == 6
                                     }">
                                    #{{ badgeData?.isYuli?.id }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 动画星盒 - 星星漂移 -->
                <div class="mainView-centerBox-starBox">
                    <div class="mainView-centerBox-starBox-star" 
                         v-for="i in 10" 
                         :class="{[`star-anim-${i}`]: true}"
                         :id="`star${i}`"
                         :key="i"
                    ></div>
                </div>
                <!-- 徽章名称 -->
                <div class="mainView-centerBox-badgeName">{{ badgeData?.label }}</div>
                <!-- 彩虹 -->
                <div class="mainView-centerBox-rainbow"></div>
            </div>
            <!-- 关闭按钮 -->
            <div class="mainView-button" @click="closeAnim">
                <!-- <img src="@/assets/images/YuliApp/weeklyTask/popup_close.png" /> -->
                <div class="mainView-button-icon">
                <img class="mainView-button-icon-left" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
                <span class="mainView-button-icon-text">Click to continue</span>
                <img class="mainView-button-icon-right" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
                </div>
            </div>
        </div>
        <div class="share" @click.self="null" :style="{
            paddingTop: statusBarHeight + 'px'
        }">
            <div class="share-textView">
                <!-- <img class="share-textView-icon" :src="require('@/assets/images/YuliApp/badgeWall/badgeAnim/share_textview.png')"> -->
                <div class="share-textView-text">
                    {{ localesPackage?.['badgewall_share_tips1']?.[localesEnv] }}
                </div>
            </div>
            <img class="share-icon" @click.stop="shareHandle" :src="require('@/assets/images/YuliApp/badgeWall/badgeAnim/icon_share.png')">
        </div>
    </div>
  </template>
<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import audioManager from "@/utils/audioManager";
import { mapState } from "vuex";

export default {
components: {},
props: {
    badgeData: {
        type: Object,
        default: () => {
            return {
                isYuli: null,
                badgeIcon: null,
                nowStar: 2,
                maxStar: 5,
                label: 'Yuli Protector III'
            }
        }
    }
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
        languageEnv: (state) => state.global.languageEnv,
        languagePackage: (state) => state.global.languagePackage,
        appUserInfo: (state) => state.global.appUserInfo,
    }),
},
watch: {
    languageEnv: {
        async handler(value) {
            if(value){
                this.localesEnv = value;
            }
        },
        immediate: true,
        deep: true,
    },
    languagePackage: {
        async handler(value) {
            if(value){
                this.localesPackage = value;
            }
        },
        immediate: true,
        deep: true,
    },
},
setup(props, { emit }) {
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    onMounted(() => {
        nextTick(() => {
            // 监听动画
            const badgeViewAnimView = document.querySelector('#badgeView-animView');
            const starElementGroup = [];
            for(let i = 1; i <= 10; i++){
                starElementGroup.push(document.querySelector(`#star${i}`));
                document.querySelector(`#star${i}`).setAttribute('style','visibility: hidden;');
            }
            let playTimes = 0;
            badgeViewAnimView.addEventListener('animationstart', () => {
                // audioManager.playEffect("upgrade");
                setTimeout(()=>{
                    starElementGroup.forEach(element => {
                        element.setAttribute('style','animation-play-state: running;');
                        element.addEventListener('animationend', () => {
                            playTimes++;
                            // if(playTimes == 10){
                            //     console.log('动画结束');
                            //     emit('handle','anim-done');
                            // }
                        })
                    })
                }, 100);
            })
        });
    });
    
    /**
     * 获取星图的class
     * @param {*} index 
     * @param {*} maxStar 
     */
    const getStarClass = (index, maxStar) => {
        return {
            'stars-view-center': maxStar == 1 || 
                    (maxStar == 2 ) ||
                    (maxStar == 3 && index == 2) || 
                    (maxStar == 4 ) || 
                    (maxStar == 5 && index == 3),
            [`stars-view-item-${index}`]: true
        }
    }

    const closeAnim = () => {
        emit('handle', 'close');
    }

    const shareHandle = () => {
        emit('handle', 'share');
    }

    return {
        getStarClass,
        closeAnim,
        shareHandle,
        localesPackage,
        localesEnv,
    };
},
};
</script>
  
<style lang="less" scoped>
@rotateSpeed: 22s;
@starMoveSpeedMid: 0.9s;
@starState: paused;
.anim-page{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1000;
    .mainView{
        width: 100%;
        height: 352px;
        box-sizing: border-box;
        padding: 10px;
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        &-title{
            width: 271px;
            height: 48px;
            margin: 0 auto;
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-centerBox{
            margin: 0 auto;
            width: 304px;
            height: 304px;
            position: relative;
            &-animBg{
                position: absolute;
                top: 0;
                left: 0;
                width: 304px;
                height: 304px;
                background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/RewardAniBg.png") no-repeat
                top left;
                background-size: 100% 100%;
                animation: rotateBg @rotateSpeed linear infinite; /* 应用旋转光效动画 */
                // 旋转
                @keyframes rotateBg {
                    0% {
                        transform: rotate(0deg);
                    }
                    100%{
                        transform: rotate(360deg);
                    }
                }
            }
            &-starBox{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 27px;
                height: 27px;
                z-index: -1;
                // 1号星星 - 透明0.8-1，Bs-80 -> Be-160 | Rs-35 -> Re-65
                .star-anim-1 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim1 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim1 {
                        0% {
                            bottom: 80px;
                            right: 35px;
                            opacity: 0.8;
                            scale: 1.2;
                        }
                        80% {
                            bottom: 160px;
                            right: 65px;
                            opacity: 1;
                            scale: 1.2;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
                // 2号星星 - 透明0.4-0.4，Bs-60 -> Be-90 | Rs-65 -> Re-85
                .star-anim-2 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim2 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim2 {
                        0% {
                            bottom: 60px;
                            right: 65px;
                            opacity: 0.4;
                            scale: 1.2;
                        }
                        80% {
                            bottom: 90px;
                            right: 85px;
                            opacity: 0.4;
                            scale: 1.2;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
                // 3号星星 - 透明0.7-0.9，Bs-10 -> Be-10 | Rs-40 -> Re-100
                .star-anim-3 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim3 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim3 {
                        0% {
                            bottom: 10px;
                            right: 40px;
                            opacity: 0.7;
                            scale: 1.3;
                        }
                        80% {
                            bottom: 10px;
                            right: 120px;
                            opacity: 0.9;
                            scale: 1.3;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
                // 4号星星 - 透明0.4-0.8，Rs-35 -> Re-90 | Ts-20 -> Te-80  
                .star-anim-4 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim4 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim4 {
                        0% {
                            top: 20px;
                            right: 35px;
                            opacity: 0.4;
                            scale: 0.8;
                        }
                        80% {
                            top: 80px;
                            right: 90px;
                            opacity: 0.8;
                            scale: 0.9;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
                // 5号星星 - 透明0.4-0.45，Rs-25 -> Re-45 | Ts-28 -> Te-135  
                .star-anim-5 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim5 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim5 {
                        0% {
                            top: 28px;
                            right: 25px;
                            opacity: 0.4;
                            scale: 0.8;
                        }
                        80% {
                            top: 135px;
                            right: 45px;
                            opacity: 0.45;
                            scale: 0.9;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
                // 6号星星 - 透明0.9 - 1，Ts-20 -> Te-110 | Ls-10 -> Le-55
                .star-anim-6 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim6 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim6 {
                        0% {
                            top: 20px;
                            left: 10px;
                            opacity: 0.9;
                            scale: 1.4;
                        }
                        80% {
                            top: 110px;
                            left: 55px;
                            opacity: 1;
                            scale: 1.4;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
                // 7号星星 - 透明0.9 - 1，Ts-14 -> Te-80 | Ls-20 -> Le-135
                .star-anim-7 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim7 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim7 {
                        0% {
                            top: 14px;
                            left: 20px;
                            opacity: 0.9;
                            scale: 1.3;
                        }
                        80% {
                            top: 80px;
                            left: 135px;
                            opacity: 1;
                            scale: 1.3;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
                // 8号星星 - 透明0.6 - 0.9，Ls-90 -> Le-185 | Bs-14 -> Be-20
                .star-anim-8 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim8 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim8 {
                        0% {
                            bottom: 14px;
                            left: 90px;
                            opacity: 0.6;
                            scale: 0.8;
                        }
                        80% {
                            bottom: 20px;
                            left: 185px;
                            opacity: 0.9;
                            scale: 0.9;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
                // 9号星星 - 透明0.9 - 0.9，Ls-55 -> Le-110 | Bs-55 -> Be-100
                .star-anim-9 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim9 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim9 {
                        0% {
                            bottom: 55px;
                            left: 55px;
                            opacity: 0.9;
                            scale: 0.8;
                        }
                        80% {
                            bottom: 100px;
                            left: 110px;
                            opacity: 0.9;
                            scale: 0.9;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
                // 10号星星 - 透明0.9 - 1，Ls-35 -> Le-45 | Bs-50 -> Be-120
                .star-anim-10 {
                    position: absolute;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/star.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    width: 27px;
                    height: 27px;
                    animation: starAnim10 @starMoveSpeedMid linear 1;
                    animation-play-state: @starState;
                    @keyframes starAnim10 {
                        0% {
                            bottom: 50px;
                            left: 35px;
                            opacity: 0.9;
                            scale: 1.4;
                        }
                        80% {
                            bottom: 120px;
                            left: 50px;
                            opacity: 1;
                            scale: 1.4;
                        }
                        100% {
                            opacity: 0;
                            scale: 0.5;
                        }
                    }
                }
            }
            &-badgeView{
                position: absolute;
                top: 46%;
                left: 49.5%;
                transform: translate(-50%, -50%);
                width: 189.2px;
                height: 189.2px;
                &-deepBg-gold{
                    mix-blend-mode: hard-light;
                    position: absolute;
                    top: 52%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 174px;
                    height: 174px;
                    opacity: 0.8;
                    z-index: 10;
                    color: transparent;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/badge_anim_bg_gold.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                }
                &-deepBg-purple{
                    mix-blend-mode: hard-light;
                    position: absolute;
                    top: 52%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 174px;
                    height: 174px;
                    opacity: 0.8;
                    z-index: 10;
                    color: transparent;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/badge_anim_bg_purple.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                }
                &-deepBg-blue{
                    mix-blend-mode: hard-light;
                    position: absolute;
                    top: 52%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 174px;
                    height: 174px;
                    opacity: 0.8;
                    z-index: 10;
                    color: transparent;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/badge_anim_bg_blue.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                }
                &-deepBg-green{
                    mix-blend-mode: hard-light;
                    position: absolute;
                    top: 52%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 174px;
                    height: 174px;
                    opacity: 0.8;
                    z-index: 10;
                    color: transparent;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/badge_anim_bg_green.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                }
                &-deepBg-white{
                    mix-blend-mode: hard-light;
                    position: absolute;
                    top: 52%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 174px;
                    height: 174px;
                    opacity: 0.8;
                    z-index: 10;
                    color: transparent;
                    background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/badge_anim_bg_white.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                }
                &-animView{
                    width: 100%;
                    height: 100%;
                    animation: stretchAnimation 0.4s cubic-bezier(0.71, -0.25, 1, 1) forwards;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    @keyframes stretchAnimation {
                        0% {
                            transform: scale(0.6);
                        }
                        33% {
                            transform: scale(1.2);
                        }
                        66% {
                            transform: scale(0.8);
                        }
                        100% {
                            transform: scale(1);
                        }
                    }
                }
            }
            &-badgeName{
                width: fit-content;
                height: fit-content;
                max-height: 58px;
                max-width: 280px;
                word-break: normal;
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                color: rgb(252, 234, 174);
                font-size: 18px;
                font-weight: 600;
                font-family: "PingFang SC";
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
            &-rainbow{
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
                width: 304px;
                height: 304px;
                background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/light_rainbow.png") no-repeat
                top left;
                background-size: 100% 100%;
            }
        }
        &-button {
            position: relative;
            z-index: 999;
            margin: 0 auto;
            margin-top: 50px;
            width: 100%;
            display: flex;
            justify-content: center;
            img {
                width: 100%;
                height: 100%;
            }
            &-icon{
                width: 148px;
                height: 16px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                &-text{
                    width: 115px;
                    height: 16px;
                    color: #bcc2c7;
                    font-size: 13px;
                    font-weight: 400;
                    font-family: "PingFang SC";
                    text-align: center;
                    word-break: keep-all;
                    line-height: 15.6px;
                }
                img{
                    width: 13px;
                    height: 5.91px;
                }
                &-left{
                    transform: rotateY(360deg);
                }
                &-right{
                    transform: rotateY(180deg);
                }
            }
        }

    }
    .share{
        position: absolute;
        top: 40px;
        right: 22px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        &-icon{
            width: 30px;
            height: 30px;
            margin-top: 10px;
        }
        &-textView{
            width: 197px;
            height: 67px;
            padding: 5px 13px 14px 6px;
            margin-right: 9px;
            box-sizing: border-box;
            background: url("~@/assets/images/YuliApp/badgeWall/badgeAnim/share_textview.png") no-repeat
            top left;
            background-size: 100% 100%;
            &-text{
                width: 100%;
                text-align: left;
                color: #ffffff;
                font-family: "PingFang SC";
                font-size: 12.7px;
                line-height: 17.5px;
                white-space: pre-line;
            }
        }
    }
    // yuli情况
    .stars-view{
        position: relative;
        &-yuliId{
            position: absolute;
            bottom: 36px;
            right: 50%;
            transform: translate(50%, 0);
            color: #F2F2F2;
            font-size: 20px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: center;
            text-shadow: 0 1px 2px rgba(64, 41, 17, 0.56), 1px 0 2px rgba(64, 41, 17, 0.56), -1px 0 2px rgba(64, 41, 17, 0.56), 0 -1px 2px rgba(64, 41, 17, 0.56);
            &-gold{
                color: #fffde7;
            }
        }
    }
}

</style>  